import React, { useEffect, useState, useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import UserService from "../../services/userServices";
import marginTopAllComponent from "../../utils/styleGlobal";
import { nbrPage, paginate, renderPagination } from "../../utils/pagination";
import { FaEdit, FaDownload, FaFileUpload, FaTrash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import RoleFilter from "../../components/filters/RoleFilter";
import { filterUsersBySearchAndRole } from "../../utils/userFilters";
import { getRoleLabel } from "../../constants/roles";
import "../../assets/style/userListePage.css";
import Loader from "../../components/loader/loader";

const UserListPage = ({ setAlert }) => {
  const { isLogged } = useContext(AuthContext);
  const [users, setUsers] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [roleFilter, setRoleFilter] = useState("all");
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const usersPerPage = nbrPage;
  const navigate = useNavigate();
  const filteredUsers = filterUsersBySearchAndRole(users, searchQuery, roleFilter);
  const BASE_URL = process.env.REACT_APP_URL_DOWNLOAD;

  useEffect(() => {
    setIsLoading(true); // Début du chargement
    UserService.getAll()
      .then((res) => {
        setUsers(res.data.data);
        setIsLoading(false);
      })
      .catch((err) => {
        console.error("Erreur:", err);
        setIsLoading(false); // Fin du chargement même en cas d'erreur
      });
  }, [isLogged]);

  const { currentData, totalPages } = paginate(filteredUsers, currentPage, usersPerPage);
  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleEdit = (user) => {
    navigate(`/user/edit/${user._id}`, { state: { user } });
  };

  const handleGenerate = (user) => {
    setUsers((prevUsers) =>
      prevUsers.map((u) =>
        u._id === user._id ? { ...u, buildStatus: 1 } : u
      )
    );

    UserService.update(user._id, { buildStatus: 1 })
      .then(() => {
        const data = {
          clientId: user._id,
        };
        return UserService.generateFile(data);
      })
      .then((res) => {
        return UserService.update(user._id, { buildStatus: 2 }).then(() => {
          setUsers((prevUsers) =>
            prevUsers.map((u) =>
              u._id === user._id ? { ...u, buildStatus: 2 } : u
            )
          );
          setAlert({ type: "success", message: "Fichier généré avec succès !" });
        });
      })
      .catch((err) => {
        console.error(err);
        UserService.update(user._id, { buildStatus: 0 }).then(() => {
          setUsers((prevUsers) =>
            prevUsers.map((u) =>
              u._id === user._id ? { ...u, buildStatus: 0 } : u
            )
          );
        });

        setAlert({ type: "danger", message: "Erreur lors de la génération. Veuillez réessayer" });
      });
  };

  const isGenerationInProgress = users.some((u) => u.buildStatus === 1);

  const handleDownload = (userId) => {
    const fileUrl = `${BASE_URL}/download/${userId}`;

    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = `nettrack Setup 1.0.0.exe`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="container-fluid px-3 pt-4"
      style={{
        marginTop: marginTopAllComponent(),
        maxWidth: "100vw",
        overflowX: "hidden",
        padding: "0 10px",
      }}>
      <h2 className="mb-4 text-center">Liste des utilisateurs</h2>

      {isLogged ? (
        isLoading ? (
          <Loader />
        ) : (
          <div
            className="table-container"
            style={{
              width: "100%",
              overflowX: "auto",
              padding: "10px",
              backgroundColor: "#f8f9fa",
              borderRadius: "10px",
              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
            }}
          >
            {/* Section Filtres */}
            <div className="filters mb-3 row gx-2">
              <div className="col-12 col-md-8 mb-2 mb-md-0">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Rechercher par nom ou email..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </div>
              <div className="col-12 col-md-4">
                <RoleFilter
                  value={roleFilter}
                  onChange={(e) => setRoleFilter(e.target.value)}
                />
              </div>
            </div>

            {/* Tableau */}
            <div
              className="table-responsive"
              style={{
                overflowX: "auto",
                backgroundColor: "#f8f9fa",
                borderRadius: "10px",
                padding: "10px",
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
              }}
            >
              <table className="table table-bordered table-hover">
                <thead className="table-primary">
                  <tr>
                    <th>#</th>
                    <th>Nom</th>
                    <th>Prénom</th>
                    <th>Email</th>
                    <th>Rôle</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {currentData.length > 0 ? (
                    currentData.map((user) => (
                      <tr key={user._id}>
                        <td>{user._id}</td>
                        <td>{user.nom}</td>
                        <td>{user.prenom}</td>
                        <td>{user.email}</td>
                        <td>{getRoleLabel(user.role)}</td>
                        <td>
                          <div className="d-flex flex-wrap gap-2 justify-content-center">
                            <button
                              className="btn btn-info btn-sm"
                              onClick={() => handleEdit(user)}
                              disabled={user.buildStatus === 1}
                            >
                              <FaEdit /> <span className="d-none d-md-inline">Modifier</span>
                            </button>

                            {/* <button
                              className="btn btn-danger btn-sm"
                              disabled={user.buildStatus === 1}
                            >
                              <FaTrash /> <span className="d-none d-md-inline">Supprimer</span>
                            </button> */}

                            {user.buildStatus === 2 && (
                              <a
                                href={`${BASE_URL}/download/${user._id}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-success btn-sm"
                              >
                                <FaDownload /> <span className="d-none d-md-inline">Télécharger</span>
                              </a>
                            )}


                            {user.buildStatus === 0 && (
                              <button
                                className="btn btn-warning btn-sm"
                                onClick={() => handleGenerate(user)}
                                disabled={isGenerationInProgress}
                                title={isGenerationInProgress ? "Une génération est déjà en cours..." : ""}
                              >
                                <FaFileUpload /> <span className="d-none d-md-inline">Générer</span>
                              </button>
                            )}

                            {user.buildStatus === 1 && (
                              <span className="btn btn-info btn-sm">
                                <span className="spinner-border spinner-border-sm me-1"></span>
                                <span className="d-none d-md-inline">Génération en cours...</span>
                                <span className="d-md-none">...</span>
                              </span>
                            )}
                          </div>
                        </td>

                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4" className="text-center text-warning">
                        Aucun utilisateur trouvé.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
              {renderPagination(totalPages, currentPage, handlePageChange)}
            </div>
          </div>
        )
      ) : (
        <p className="text-danger text-center">Vous devez être connecté.</p>
      )}
    </div>
  );
};

export default UserListPage;